/**
 * rateQuestion.js
 * Written by: Alex Kasemir
 */

import request from '../../../request/actions';

import event from '../../../../utils/event';

export const RATE_QUESTION_START = `RATE_QUESTION_START`;
export const RATE_QUESTION_SUCCESS = `RATE_QUESTION_SUCCESS`;
export const RATE_QUESTION_FAILURE = `RATE_QUESTION_FAILURE`;

export const rateQuestionStart = () => ({
  type: RATE_QUESTION_START,
});

export const rateQuestionSuccess = (data) => ({
  type: RATE_QUESTION_SUCCESS,
  data,
});

export const rateQuestionFailure = (error) => ({
  type: RATE_QUESTION_FAILURE,
  error,
});

/**
 * Description of the rateQuestion action
 */
export const rateQuestion = (id, data) => {
  return (dispatch) => {
    dispatch(rateQuestionStart());
    return dispatch(request(`/questions/${id}/rating/`, `POST`, { ...data }))
      .then((response) => {
        dispatch(rateQuestionSuccess(response.data));
        event(`rate-question`, [`click`, `rate-question`, `${id}`]);
      })
      .catch((error) => {
        dispatch(rateQuestionFailure(error.response));
      });
  };
};

export default rateQuestion;
